// extracted by mini-css-extract-plugin
export default {"watchCounter":"NotificationsSubscriptionsMenu-module__watchCounter--nAbhU","watchButton":"NotificationsSubscriptionsMenu-module__watchButton--ifxlS"};